import React from 'react';
import { useTranslation } from 'react-i18next';
import './RankingMethodSelector.css';

const RankingMethodSelector = ({ rankingMethod, onRankingMethodChange }) => {
  const { t } = useTranslation(['discovery']);

  const rankingMethods = [
    { id: 'subscribers', name: t('channelDiscovery.rankingMethod.subscribers') },
    { id: 'views', name: t('channelDiscovery.rankingMethod.views') },
    { id: 'videos', name: t('channelDiscovery.rankingMethod.videos') },
    { id: 'relevance', name: t('channelDiscovery.rankingMethod.relevance') },
    { id: 'engagement', name: t('channelDiscovery.rankingMethod.engagement') },
  ];

  const handleRankingMethodChange = (event) => {
    onRankingMethodChange(event.target.value);
  };

  return (
    <div className="ranking-method-selector">
      <select
        id="ranking-method"
        className="ranking-method-selector__select"
        value={rankingMethod}
        onChange={handleRankingMethodChange}
      >
        {rankingMethods.map((method) => (
          <option key={method.id} value={method.id}>
            {method.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default RankingMethodSelector;